import router from '@/router';

const HTTP_REG = /^https?:\/\//i;

function normalizeInternalPath(url) {
  return url.startsWith('/') ? url : `/${url}`;
}

function stripEduPrefix(pathname) {
  return pathname.replace(/^\/edu(?=\/|$)/, '') || '/';
}

function isInRouterScope(pathname) {
  const path = stripEduPrefix(pathname);
  const matched = router.match(path);
  return matched.matched.length > 0 && matched.name !== 'notFound';
}

/**
 * 根据 URL 智能跳转：支持站内 router 跳转与 window.open 外链打开。
 * @param {string} url - 跳转地址
 * @param {boolean} [shouldValidate=true] - 是否校验 URL；false 时直接 window.open
 * @param {string} [target='_blank'] - window.open 的 target，仅外链 / 不校验时生效
 */
export function jumpByLink(url, shouldValidate = true, target = '_blank') {
  if (!url || url.startsWith('#')) return;

  if (!shouldValidate) {
    window.open(url, target);
    return;
  }

  if (!HTTP_REG.test(url)) {
    router.push(normalizeInternalPath(url));
    return;
  }

  try {
    const { origin, pathname, search, hash } = new URL(url);

    if (origin !== window.location.origin || !isInRouterScope(pathname)) {
      window.open(url, target);
      return;
    }

    router.push(stripEduPrefix(pathname) + search + hash);
  } catch {
    window.open(url, target);
  }
}
